import TableComponent from "app/common/Component/Table/TableComponent";
import { formatMoney, getDateTime } from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

const HistoryChangeRemainTabList = () => {
  const { t } = useTranslation();
  const {
    pageHistoryChangeRemain,
    handleChangeFormSearch,
    searchHistoryChangeRemain,
  } = useStore().feeStore.historyChangeRemainTabStore;
  return (
    <>
      <TableComponent
        showOrdinalNumbers
        titleNodata={t("noData")}
        data={pageHistoryChangeRemain?.content || []}
        // minWidth={"820px"}
        columns={[
          {
            field: "clientCard.code",
            title: t("Ngày giao dịch"),
            render: (val) => {
              return <div>{getDateTime(val?.transationDate)}</div>;
            },
          },
          {
            field: "department.name",
            title: t("Cơ sở giao dịch"),
          },
          {
            field: "createdBy",
            title: "Người tạo",
          },
          {
            field: "quantity",
            title: t("Nội dung giao dịch"),
            render: (data) => (
              <span className="cell-content">
                <>
                  {data?.invoiceItem?.invoiceItemName
                    ? data?.invoiceItem?.invoiceItemName
                    : data?.transactionType > 0
                    ? data?.voucherItem?.voucher?.note
                    : "Cọc tiền"}
                </>
              </span>
            ),
          },
          {
            field: "practitioner.staffName",
            title: t("Số tiền giao dịch"),
            align: "right",
            render: (data) => (
              <span
                className={`cell-amount ${
                  data?.transactionType > 0 ? "text-green" : "text-red"
                }`}
              >
                {data?.transactionType > 0 ? "+" : "-"}{" "}
                {formatMoney(data?.amount)}
              </span>
            ),
          },
          {
            field: "parentTransaction.invoiceItem.invoiceItemName",
            title: t("Từ đơn hàng"),
            align: "right",
          },
        ]}
        dataPagination={{
          pageIndex: searchHistoryChangeRemain?.pageIndex,
          pageSize: searchHistoryChangeRemain?.pageSize,
          totalElements: pageHistoryChangeRemain?.totalElements,
          totalPages: pageHistoryChangeRemain?.totalPages,
          setPageIndex: (pageIndex) => handleChangeFormSearch({ pageIndex }),
          setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
        }}
      />
    </>
  );
};

export default observer(HistoryChangeRemainTabList);
